import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class IntercardDataService {
  observables: object = {};
  obsRegistry: object = {};

  register(cardId: string): Observable<object> {
    let observables = this.observables;
    // console.log( "Registering card: ", cardId, observables[cardId] );

    // If we have already registered this ID, return the existing observable
    if (observables[cardId]) {
      return this.observables[cardId];
    }

    let newObs = new Observable<object>((observer) => {
      this.obsRegistry[cardId] = observer;
    });
    this.observables[cardId] = newObs;

    // console.log( "Returning obs: ", newObs );
    return newObs;
  }

  emitData(destId: string, data: any) {
    // console.log( "Received request to emit: ", destId, data );
    let dest = this.obsRegistry[destId];

    if (dest) {
      dest.next(data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/intercard-data/intercard-data.service.ts